import React, { Component } from 'react';
import moment from 'moment';

import CamdetectCamerasSettingForm from './CamdetectCamerasSettingForm';
import CamdetectCamerasPasswordForm from './CamdetectCamerasPasswordForm';

import { defaultSorter, dateSorter } from './Helpers';
import CamdetectCamerasModel from './CamdetectCamerasModel';
import UserModel from './UserModel';

import { Table, Badge, Row, Col, Statistic, Popconfirm, Divider, message, Card, Typography } from 'antd';

class CamdetectCamerasTable extends Component {

  state = {
    children: [],
    filteredInfo: {},
    sortedInfo: {},
    camdetectCameraSettingsFormData: null,
    camdetectCameraPasswordFormData: null
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter,
    });
  }

  expandedRowRender(record) {
    return (
      <div>
        <Row style={{ marginBottom: 20 }}>
          <Col span={3}>
            <Statistic
              formatter={(value) => { if (value) return "ANO"; else return "NE" }}
              title="Trvalé napájení"
              value={record.grid} />
          </Col>
          <Col span={3}>
            <Statistic
              formatter={(value) => { if (value) return value; else return "-" }}
              title="Napětí baterie [V]"
              value={record.voltage} />
          </Col>
          <Col span={3}>
            <Statistic
              formatter={(value) => { if (value) return value; else return "-" }}
              title="Teplota [°C]"
              value={record.temperature} />
          </Col>
          <Col span={5}>
            <Statistic
              formatter={(value) => {
                var uptimeString = "";
                if (record.uptime != 0) {
                  if (moment.duration(record.uptime, "seconds").days() != 0) {
                    uptimeString += moment.duration(record.uptime, "seconds").days() + ' d ';
                  }
                  if (moment.duration(record.uptime, "seconds").hours() != 0) {
                    uptimeString += moment.duration(record.uptime, "seconds").hours() + ' h ';
                  }
                  if (moment.duration(record.uptime, "seconds").minutes() != 0) {
                    uptimeString += moment.duration(record.uptime, "seconds").minutes() + ' min ';
                  }
                  if (moment.duration(record.uptime, "seconds").seconds() != 0) {
                    uptimeString += moment.duration(record.uptime, "seconds").seconds() + ' s';
                  }
                } else {
                  uptimeString = "0 s";
                }
                return uptimeString;
              }}
              title="Doba provozu"
              value={record.uptime} />
          </Col>
          <Col span={16}>
            <Statistic
              formatter={(value) => { if (value) return moment(value).format('L LTS'); else return "-" }}
              title="Čas technologických dat"
              value={record.techDataTimestamp} />
          </Col>
          <Col span={24}>
            <Card title="Poslední detekce">
              <img src={record.lastImage} width="800" height="450" alt="lastImage" />
            </Card>
          </Col>
        </Row>
      </div >
    );
  }

  render() {

    let { sortedInfo, filteredInfo } = this.state;

    const columns = [{
      title: 'Lokalita',
      dataIndex: 'parkingLocationName',
      key: 'parkingLocationName',
      width: 270,
      sorter: (a, b) => defaultSorter(a.parkingLocationName, b.parkingLocationName)
    }, {
      title: 'Název kamery',
      dataIndex: 'cameraName',
      key: 'cameraName',
      width: 100,
      sorter: (a, b) => defaultSorter(a.cameraName, b.cameraName)
    }, {
      title: 'Obsazeno Parking',
      dataIndex: 'occ',
      key: 'occ',
      width: 75,
      sorter: (a, b) => defaultSorter(a.occ, b.occ)
    }, {
      title: 'Obsazeno Invalidé',
      dataIndex: 'disabledOcc',
      key: 'disabledOcc',
      width: 75,
      sorter: (a, b) => dateSorter(a.disabledOcc, b.disabledOcc),
    }, {
      title: 'Počítat invalidy do TotalOcc parkoviště',
      dataIndex: 'countDisabledToTotal',
      key: 'countDisabledToTotal',
      width: 75,
      render: (text, record) => {
        if (record.countDisabledToTotal) {
          return ('ANO');
        } else {
          return ('NE');
        }
      },
    }, {
      title: 'Poslední změna stavu',
      dataIndex: 'lastChange',
      key: 'lastChange',
      width: 185,
      defaultSortOrder: 'descend',
      sorter: (a, b) => dateSorter(a.lastChange, b.lastChange),
      render: (text, record) => {
        if (moment(record.lastChange) <= moment().subtract(120, "minutes")) {
          return (
            <Badge
              status="error"
              text={moment(text).format('L LTS')}
              title="Poslední komunikace před více než 2 hodinami" />
          );
        } else if (moment(record.lastChange) <= moment().subtract(60, "minutes")) {
          return (
            <Badge
              status="warning"
              text={moment(text).format('L LTS')}
              title="Poslední komunikace před více než 60 minutami" />
          );
        } else {
          return (
            <Badge
              status="success"
              text={moment(text).format('L LTS')}
              title="Vpořádku" />
          );
        }
      }
    }, {
      title: 'Upozornění',
      dataIndex: 'reportsEnabled',
      key: 'reportsEnabled',
      width: 130,
      filters: [{
        text: 'ZAPNUTO',
        value: true,
      }, {
        text: 'VYPNUTO',
        value: false,
      }],
      filteredValue: filteredInfo.reportsEnabled || null,
      onFilter: (value, record) => { return ((record.reportsEnabled === value)) ? true : false },
      render: (text, record) => {
        if (record.reportsEnabled === true) {
          return (
            <Badge
              status="success"
              text="ZAPNUTO" />
          );
        } else {
          return (
            <Badge
              status="error"
              text="VYPNUTO"
              title="Vpořádku" />
          );
        }
      }
    }, {
      title: 'Akce',
      key: 'Action',
      width: 200,
      render: (text, record) => {
        if (UserModel.isInRoles(['ADMIN', 'CAMDETECT_CAMERAS_WRITE'])) {
          return (
            <div>
              <a onClick={(e) => {
                this.setState({
                  camdetectCameraSettingsFormData: record
                });
              }}>Nastavení</a>
              <Divider type="vertical" />
              <a onClick={(e) => {
                this.setState({
                  camdetectCameraPasswordFormData: record
                });
              }}>Změna hesla</a>
              <Divider type="vertical" />
              <Popconfirm placement="right" title="Opravdu si přejete záznam smazat?" onConfirm={() => {
                this.props.onRemoveRow
                  ? this.props.onRemoveRow(record.id)
                  : null;
              }} okText="Ano" cancelText="Ne">
                <a onClick={(e) => { e.preventDefault(); }}><Typography.Text type="danger">Smazat</Typography.Text></a>
              </Popconfirm>
            </div>
          );
        }
      }
    }];

    return (
      <div>
        <Table
          size='small'
          rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
          loading={this.props.loading ? this.props.loading : false}
          columns={columns}
          dataSource={this.props.data}
          onChange={this.handleChange}
          pagination={{
            showSizeChanger: true,
            defaultPageSize: localStorage.getItem('table_pageSize') !== undefined
              ? parseInt(localStorage.getItem('table_pageSize'))
              : 10,
            onShowSizeChange: (current, size) => {
              localStorage.setItem('table_pageSize', size);
            }
          }}
          expandedRowRender={this.expandedRowRender.bind(this)}
          style={{ border: '0px' }} />
        <CamdetectCamerasSettingForm
          type="modal"
          modalVisible={this.state.camdetectCameraSettingsFormData === null ? false : true}
          initialValues={this.state.camdetectCameraSettingsFormData}
          onModalCancel={(form) => {
            form.resetFields();
            this.setState({ camdetectCameraSettingsFormData: null });
          }}
          onSuccess={(form, values) => {
            CamdetectCamerasModel.patch(this.state.camdetectCameraSettingsFormData.id, values)
              .then(() => {
                message.success("Změna byla uložena!");
                form.resetFields();
                this.setState({
                  camdetectCameraSettingsFormData: null
                });
                if (this.props.onAnyFormSuccess) {
                  this.props.onAnyFormSuccess();
                }
              })
              .catch(err => {
                message.warning('Změnu se nepodařilo uložit. Zkontrolujte spravnou funkčnost služby.');
              })
          }} />
        <CamdetectCamerasPasswordForm
          type="modal"
          modalVisible={this.state.camdetectCameraPasswordFormData === null ? false : true}
          initialValues={this.state.camdetectCameraPasswordFormData}
          onModalCancel={(form) => {
            form.resetFields();
            this.setState({ camdetectCameraPasswordFormData: null });
          }}
          onSuccess={(form, values) => {
            CamdetectCamerasModel.patch(this.state.camdetectCameraPasswordFormData.id, values)
              .then(() => {
                message.success("Změna byla uložena!");
                form.resetFields();
                this.setState({
                  camdetectCameraPasswordFormData: null
                });
                if (this.props.onAnyFormSuccess) {
                  this.props.onAnyFormSuccess();
                }
              })
              .catch(err => {
                message.warning('Změnu se nepodařilo uložit. Zkontrolujte spravnou funkčnost služby.');
              })
          }} />
      </div>
    );
  }
}

export default CamdetectCamerasTable;


// WEBPACK FOOTER //
// ./src/components/CamdetectCamerasTable.js